



































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputSelectCompany extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly companies!: Company[]
    @Prop() readonly value!: Company
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: Company = null
    showOptions: boolean = false

    created() {
        this.internalValue = this.value
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        await this.validator.validate(this.internalValue)
        this.$emit('input', this.internalValue)
    }

    applyClass(option: Company) {
        if (this.value && this.value.id === option.id) {
            return ['input-select__option--selected']
        }

        return []
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    selectOption(option: Company): void {
        this.internalValue = option
        this.showOptions = false
    }

    get selectedOption() {
        if (!this.value) {
            return null
        }

        return this.companies.find(value => value.id === this.value.id)
    }

    get componentClass(): object {
        return {
            'input-select': true,
            'input-select-company': true,
            'input-select--disabled': this.disabled,
        }
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
